import Lab from "../features/Lab";
import FolderManager from "../features/FolderManager";
import { Version } from "../features/Version";
import Issue from "../features/Issue";
import SafePlaceQR from "../features/SafePlaceQR";
import Help from "../features/Help";
import Issues from "../features/Help/Issue";
import CashSheet from "features/CashSheet";
import Planning from "features/Planning";

const routes = [
	{
		path: "/home/lab",
		exact: false,
		component: Lab,
	},
	{
		path: "/home/foldermanager",
		exact: false,
		component: FolderManager,
	},
	{
		path: "/home/about",
		exact: false,
		component: Version,
	},
	{
		path: "/home/help",
		exact: false,
		component: Help,
	},
	{
		path: "/home/versions",
		exact: false,
		component: Issues,
	},
	{
		path: "/home/issues",
		exact: false,
		component: Issue,
	},
	{
		path: "/home/safeplaceqr",
		exact: false,
		component: SafePlaceQR,
	},
	{
		path: "/home/facturation",
		exact: false,
		component: CashSheet,
	},
	{
		path: "/home/planning",
		exact: false,
		component: Planning,
	},
];

export default routes;
